import styled from 'styled-components';

const LoginLogo = styled.img`
    margin-bottom: 0;
    margin-top: 20px;
    max-height: 60px;
    max-width: 200px;
`;

export default LoginLogo;
